<!--- Componente Datos Auxiliares Linea Pedido Venta ---->
<!---
Descripción del componente y comportamiento:
---------------------------
-

Eventos escuchados por el componente:
-----------------------
-

Eventos generados por el componente:
-----------------------
-  XXXXXXX ->
--->

<template>
  <div>
    <UCPreload
      :show="preloader"
      :numero-elementos="1"
    />
    <div class="container">
      <div
        v-for="item in datosAuxiliares"
        :key="item.Orden"
        class="item"
      >
        <span class="item-nombre">{{ item.Nombre }}</span>
        <span class="item-valor">{{ item.Valor }}</span>
      </div>
    </div>

    <!-- <pre>{{ datosAuxiliares }}</pre> -->
  </div>
</template>

<script>
import { Log } from '@/js/common/HIDebuggingSupport';
import UCPreload from '@/components/common/UCPreload.vue';
import {
  HiNotification,
} from '@/js/common/HINotificationSupport';
import ConexionTA from '@/js/services/traceability/APITraceability';

export default {
  name: 'PCDatosAuxiliaresLineaPedidoVenta',
  components: {
    UCPreload,
  },
  props: {
    activo: {
      type: Boolean,
      default: false,
    },
    lineaPedidoVenta: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      objLineaPedidoVentaSeleccionada: null,
      datosAuxiliares: [],
      preloader: false,
    };
  },

  watch: {
    activo(val) {
      if (val && this.lineaPedidoVenta != null) {
        this.CargarDatosAuxiliaresLineaPedidoVenta(this.lineaPedidoVenta);
      } else {
        this.RestablecerComponent();
      }
    },
  },

  methods: {
    RestablecerComponent() {
      this.objLineaPedidoVentaSeleccionada = null;
      this.datosAuxiliares = [];
    },
    /** * Método CargarDatosAuxiliaresLineaPedidoVenta */
    async CargarDatosAuxiliaresLineaPedidoVenta(objLpv) {
      Log(this, this.CargarDatosAuxiliaresLineaPedidoVenta.name);
      this.preloader = true;
      this.objLineaPedidoVentaSeleccionada = objLpv;
      this.datosAuxiliares = await this.Conexion_ObtenerDatosAuxiliaresXLineaPedidoVenta(this.objLineaPedidoVentaSeleccionada);
      this.preloader = false;
    },

    /** * Método Conexion_ObtenerDatosAuxiliaresXLineaPedidoVenta */
    async Conexion_ObtenerDatosAuxiliaresXLineaPedidoVenta(objLpv) {
      Log(this, this.Conexion_ObtenerDatosAuxiliaresXLineaPedidoVenta.name);
      try {
        const result = await ConexionTA.callObtenerDatosAuxiliaresXLineaPedidoVenta(objLpv.Id);
        if (result.Valor) {
          return JSON.parse(result.Mensaje);
        }
      } catch {
        HiNotification.Toast(this.$t('common.checkYourConnection'));
      }
      return [];
    },
  },
};
</script>

<style scoped>
.div-cabeceraTitulo {
  color: #24253d;
  text-transform: none;
  font-size: 22px;
  background: var(--his-tierra-white);
  padding-left: 25px;
  border-bottom: 4px;
  border-top: 0;
  border-right: 0;
  border-left: 0;
  border-color: var(--his-disabled);
  border-style: solid;
}

.container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: baseline;
  align-content: stretch;
}

.item {
  flex-grow: 4; /* default 0 */
  margin-left: 2%;
  display: grid;
  padding-top: 12px;
  padding-left: 2px;
  padding-right: 2px;
  padding-bottom: 1px;
  text-align: center;
  border-radius: 10px;
  background-color: var(--his-tierra-white);
  min-height: 49px;
  margin-right: 2%;
  margin-top: 10px;
}

.item-valor {
  color: var(--his-darkgray);
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
  text-align: center;
}

.item-nombre {
  color: var(--his-ash-gray);
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
}
</style>
